import { get, post } from '@/request/http'



export function getImg(axios, params) {
    return post(axios.defaults.imgURL + '/BigScreen/index', params)
}



// WEBPACK FOOTER //
// ./src/api/Interface.js